import createCache from '@emotion/cache'
import emotionStyled from '@emotion/styled'

export const emotionReact = require('@emotion/react')

import jsxRuntime from 'react/jsx-runtime'

export const clientExternals = {
	'@emotion/cache': createCache,
	'@emotion/react': emotionReact,
	'@emotion/styled': emotionStyled,
	jsxRuntime,
}
